// extracted by mini-css-extract-plugin
export default {"form-checkbox-container":"CheckBox_form-checkbox-container__s6pBq"};